import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import BookingLink from "../button/BookingLink";

export const PRICE_UPDATE_NOTICE_STORAGE_KEY =
  "price-update-notice-v1-dismissed";

const hasDismissedNotice = () => {
  try {
    return sessionStorage.getItem(PRICE_UPDATE_NOTICE_STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

const rememberDismissal = () => {
  try {
    sessionStorage.setItem(PRICE_UPDATE_NOTICE_STORAGE_KEY, "true");
  } catch (error) {
    // The modal remains dismissible when browser storage is unavailable.
  }
};

const PriceUpdateModal = () => {
  const [show, setShow] = useState(() => !hasDismissedNotice());

  const handleClose = () => {
    setShow(false);
    rememberDismissal();
  };

  return (
    <Modal
      className="price-update-modal"
      show={show}
      onHide={handleClose}
      backdrop
      keyboard
      centered
      aria-labelledby="price-update-modal-title"
      aria-describedby="price-update-modal-description"
      dialogClassName="price-update-modal-dialog"
    >
      <div className="modal-content">
        <Modal.Header>
          <Modal.Title as="h2" id="price-update-modal-title">
            Mise à jour des tarifs
          </Modal.Title>
          <button
            type="button"
            className="close"
            onClick={handleClose}
            aria-label="Fermer la fenêtre"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="price-update-modal-icon" aria-hidden="true">
            <i className="fas fa-info" />
          </div>
          <p className="price-update-modal-highlight">
            Je souhaitais t’informer que mes tarifs ont récemment évolué.
          </p>
          <p id="price-update-modal-description">
            Retrouve toutes les informations à jour sur Planity avant de
            prendre ton rendez-vous.
          </p>

          <div className="price-update-modal-actions">
            <BookingLink
              className="btn price-update-modal-primary"
              showExternalIcon
            >
              Consulter les tarifs sur Planity
            </BookingLink>
            <button
              type="button"
              className="btn btn-link price-update-modal-dismiss"
              onClick={handleClose}
            >
              Continuer sur le site
            </button>
          </div>
        </Modal.Body>
      </div>
    </Modal>
  );
};

export default PriceUpdateModal;
